import { generateCopilotRules } from "./copilot.js";

/**
 * Generate Windsurf rules (~12KB).
 * Same content as Copilot.
 */
export function generateWindsurfRules(): string {
  return generateCopilotRules();
}
